"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FetchEnabledFeaturesError = void 0;
exports.fetchEnabledFeatures = fetchEnabledFeatures;
var _error = require("@ori/error");
var _debug = _interopRequireDefault(require("debug"));
var _getFeatureToggles = require("./getFeatureToggles");
const debug = (0, _debug.default)('@ori-appshell/config:fetchEnabledFeatures');

/** @deprecated Use the `GetEnabledFeaturesError` constant from the `@ori/feature-toggles` library */
const FetchEnabledFeaturesError = exports.FetchEnabledFeaturesError = (0, _error.createCustomError)('FetchEnabledFeaturesError', {
  NO_FEATURE_SPECIFIED: 'At least one feature must be specified to be fetched'
});

/** @deprecated Use the `GetEnabledFeaturesOptions` interface from the `@ori/feature-toggles` library */

/**
 * Get a list of enabled features specified by `requestedFeatures`.
 *
 * From all existing features only those passed in `requestedFeatures` array (e.g. those that a consumer cares about) are picked.
 * Then from this list only those enabled are returned to optimize the size of the transferred data.
 * @param requestedFeatures List of features for which the enabled status is returned
 * @param options Configuration options
 * @returns A set of enabled features
 *
 * @deprecated Use the `getFeatureToggles` function from the `@ori/feature-toggles` library
 */
async function fetchEnabledFeatures(requestedFeatures, {
  apiUrl,
  tenant,
  token
}) {
  if (requestedFeatures.length === 0) {
    throw new FetchEnabledFeaturesError('NO_FEATURE_SPECIFIED');
  }
  let toggles;
  try {
    toggles = await (0, _getFeatureToggles.getFeatureToggles)(apiUrl, tenant, token);
  } catch (error) {
    debug(error);
  }
  if (!toggles) {
    return [];
  }

  // only enabled features are left, false value is the same as when the feature doesn't exist
  const enabledFeatures = toggles.filter(toggle => toggle.IsEnabled).reduce((accumulator, feature) => accumulator.add(feature.Id), new Set());
  return requestedFeatures.filter(feature => enabledFeatures.has(feature));
}
